var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 15.8334H15.0002V7.63093L10.0002 3.08593L5.00016 7.63093V15.8334ZM15.8335 17.5001H4.16683C3.94582 17.5001 3.73385 17.4123 3.57757 17.256C3.42129 17.0997 3.3335 16.8878 3.3335 16.6668V9.16676H0.833496L9.43933 1.34343C9.59275 1.20383 9.79273 1.12646 10.0002 1.12646C10.2076 1.12646 10.4076 1.20383 10.561 1.34343L19.1668 9.16676H16.6668V16.6668C16.6668 16.8878 16.579 17.0997 16.4228 17.256C16.2665 17.4123 16.0545 17.5001 15.8335 17.5001ZM6.25016 10.8334H7.91683C7.91683 11.386 8.13632 11.9159 8.52702 12.3066C8.91772 12.6973 9.44763 12.9168 10.0002 12.9168C10.5527 12.9168 11.0826 12.6973 11.4733 12.3066C11.864 11.9159 12.0835 11.386 12.0835 10.8334H13.7502C13.7502 11.828 13.3551 12.7818 12.6518 13.4851C11.9486 14.1883 10.9947 14.5834 10.0002 14.5834C9.0056 14.5834 8.05177 14.1883 7.34851 13.4851C6.64525 12.7818 6.25016 11.828 6.25016 10.8334Z",
    fill: "#09121F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHome);
export default __webpack_public_path__ + "static/media/SidebarHome.f42dd6b33a0ec3f475e6bb1d1b107ff0.svg";
export { ForwardRef as ReactComponent };